function unlockPageScroll() {
  document.body.classList.remove('overflow-hidden');
  document.documentElement.classList.remove('overflow-hidden');

  document.body.classList.forEach(function(className) {
    if (className.indexOf('overflow-hidden-') === 0) {
      document.body.classList.remove(className);
    }
  });

  document.body.style.removeProperty('overflow');
  document.documentElement.style.removeProperty('overflow');
  document.body.style.removeProperty('position');
  document.body.style.removeProperty('top');
  document.body.style.removeProperty('width');
}

function lockPageScroll() {
  if (document.body.classList.contains('icart-drawer-open')) return;
  document.body.classList.add('overflow-hidden');
}

let nativeCartDrawerVisibleWhenActive = null;

function isNativeCartDrawerVisible() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return false;

  if (nativeCartDrawerVisibleWhenActive === null) {
    const wasActive = drawer.classList.contains('active');
    drawer.classList.add('active');
    nativeCartDrawerVisibleWhenActive =
      window.getComputedStyle(drawer).display !== 'none';
    if (!wasActive) drawer.classList.remove('active');
  }

  return nativeCartDrawerVisibleWhenActive;
}

let cartIconRefreshTimer;

function refreshCartIconBubble() {
  return fetch('/?sections=cart-icon-bubble')
    .then(function(response) {
      return response.json();
    })
    .then(function(sections) {
      const sectionHtml = sections['cart-icon-bubble'];
      if (!sectionHtml) return;

      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const sectionRoot =
        parsed.querySelector('.shopify-section') ||
        parsed.getElementById('shopify-section-cart-icon-bubble');
      const sectionInner = sectionRoot ? sectionRoot.innerHTML : sectionHtml;

      const cartIcon = document.getElementById('cart-icon-bubble');
      if (!cartIcon || !sectionInner) return;

      cartIcon.innerHTML = sectionInner;

      return fetch('/cart.js').then(function(r) {
        return r.json();
      });
    })
    .then(function(cart) {
      if (!cart) return;

      const cartIcon = document.getElementById('cart-icon-bubble');
      if (!cartIcon) return;

      cartIcon.classList.toggle('header__cart--empt', cart.item_count < 1);

      const bubble = cartIcon.querySelector('.cart-count-bubble');
      if (bubble) {
        bubble.hidden = cart.item_count < 1;
      }
    })
    .catch(function(err) {
      console.warn('Cart icon refresh failed:', err);
    });
}

function scheduleCartIconRefresh() {
  window.clearTimeout(cartIconRefreshTimer);
  cartIconRefreshTimer = window.setTimeout(refreshCartIconBubble, 200);
}

function patchFetchForCartIconRefresh() {
  if (window.__cartIconFetchPatched) return;
  window.__cartIconFetchPatched = true;

  const originalFetch = window.fetch;

  window.fetch = function() {
    const input = arguments[0];
    const url =
      typeof input === 'string' ? input : input && input.url ? input.url : '';

    return originalFetch.apply(this, arguments).then(function(response) {
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(url) && response.ok) {
        scheduleCartIconRefresh();
      }
      return response;
    });
  };
}

function initCartIconSync() {
  if (window.__cartIconSyncInit) return;
  window.__cartIconSyncInit = true;

  ['cart:updated', 'cart:change', 'cart:refresh', 'ajaxCart:updated'].forEach(
    function(eventName) {
      document.addEventListener(eventName, scheduleCartIconRefresh);
    }
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      if (event.source === 'cart-items') return;
      scheduleCartIconRefresh();
    });
  }

  patchFetchForCartIconRefresh();
}

function watchIcartDrawerClose() {
  if (window.__icartScrollUnlockObserver) return;
  window.__icartScrollUnlockObserver = true;

  let icartWasOpen = document.body.classList.contains('icart-drawer-open');

  const observer = new MutationObserver(function() {
    const icartIsOpen = document.body.classList.contains('icart-drawer-open');

    if (icartWasOpen && !icartIsOpen) {
      unlockPageScroll();
      scheduleCartIconRefresh();

      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.remove('active', 'animate');
      }

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus();
      }
    }

    icartWasOpen = icartIsOpen;
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
}

initCartIconSync();
watchIcartDrawerClose();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    if (isNativeCartDrawerVisible()) {
      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement =
            this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );

      lockPageScroll();
    }
  }

  close() {
    this.classList.remove('active', 'animate');
    removeTrapFocus(this.activeElement);
    unlockPageScroll();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerClose extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const drawer = this.closest('cart-drawer');
      if (drawer) drawer.close();
    });
  }
}

customElements.define('cart-drawer-close', CartDrawerClose);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
